var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    { class: _vm.containerClass, attrs: { "aria-label": _vm.navLabel } },
    [
      !_vm.noLiSurround
        ? _c(
            "ul",
            [
              _vm.firstLastButton
                ? _c(
                    "li",
                    {
                      class: [
                        _vm.pageClass,
                        _vm.firstPageSelected() ? _vm.disabledClass : "",
                      ],
                    },
                    [
                      _c(
                        "a",
                        {
                          class: _vm.pageLinkClass,
                          attrs: {
                            tabindex: _vm.firstPageSelected() ? -1 : 0,
                            "aria-disabled": _vm.firstPageSelected()
                              ? "true"
                              : null,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.selectFirstPage()
                            },
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.selectFirstPage()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t" +
                              _vm._s(_vm.firstButtonText) +
                              "\n\t\t\t"
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !(_vm.firstPageSelected() && _vm.hidePrevNext)
                ? _c(
                    "li",
                    {
                      class: [
                        _vm.prevClass,
                        _vm.firstPageSelected() ? _vm.disabledClass : "",
                      ],
                    },
                    [
                      _c(
                        "a",
                        {
                          class: _vm.prevLinkClass,
                          attrs: {
                            tabindex: _vm.firstPageSelected() ? -1 : 0,
                            "aria-disabled": _vm.firstPageSelected()
                              ? "true"
                              : null,
                            "aria-label": _vm.prevLabel,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.prevPage()
                            },
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.prevPage()
                            },
                          },
                        },
                        [
                          _vm._t("prevContent", function () {
                            return [_vm._v(_vm._s(_vm.prevText))]
                          }),
                        ],
                        2
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.pages, function (page) {
                return _c(
                  "li",
                  {
                    class: [
                      _vm.pageClass,
                      page.selected ? _vm.activeClass : "",
                      page.disabled ? _vm.disabledClass : "",
                      page.breakView ? _vm.breakViewClass : "",
                    ],
                  },
                  [
                    page.breakView
                      ? _c(
                          "a",
                          {
                            class: [_vm.pageLinkClass, _vm.breakViewLinkClass],
                            attrs: {
                              tabindex: "0",
                              "aria-current": page.selected ? "page" : null,
                              "aria-disabled": page.disabled ? "true" : null,
                            },
                          },
                          [
                            _vm._t("breakViewContent", function () {
                              return [_vm._v(_vm._s(_vm.breakViewText))]
                            }),
                          ],
                          2
                        )
                      : page.disabled
                      ? _c(
                          "a",
                          {
                            class: _vm.pageLinkClass,
                            attrs: {
                              tabindex: "0",
                              "aria-current": page.selected ? "page" : null,
                              "aria-disabled": page.disabled ? "true" : null,
                            },
                          },
                          [
                            _c("span", { staticClass: "screen-reader-text" }, [
                              _vm._v(_vm._s(_vm.pageLabel) + " "),
                            ]),
                            _vm._v(_vm._s(page.content) + "\n\t\t\t"),
                          ]
                        )
                      : _c(
                          "a",
                          {
                            class: _vm.pageLinkClass,
                            attrs: {
                              tabindex: "0",
                              "aria-current": page.selected ? "page" : null,
                              "aria-disabled": page.disabled ? "true" : null,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handlePageSelected(page.index)
                              },
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.handlePageSelected(page.index)
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "screen-reader-text" }, [
                              _vm._v(_vm._s(_vm.pageLabel) + " "),
                            ]),
                            _vm._v(_vm._s(page.content) + "\n\t\t\t"),
                          ]
                        ),
                  ]
                )
              }),
              _vm._v(" "),
              !(_vm.lastPageSelected() && _vm.hidePrevNext)
                ? _c(
                    "li",
                    {
                      class: [
                        _vm.nextClass,
                        _vm.lastPageSelected() ? _vm.disabledClass : "",
                      ],
                    },
                    [
                      _c(
                        "a",
                        {
                          class: _vm.nextLinkClass,
                          attrs: {
                            tabindex: _vm.lastPageSelected() ? -1 : 0,
                            "aria-disabled": _vm.lastPageSelected()
                              ? "true"
                              : null,
                            "aria-label": _vm.nextLabel,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.nextPage()
                            },
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.nextPage()
                            },
                          },
                        },
                        [
                          _vm._t("nextContent", function () {
                            return [_vm._v(_vm._s(_vm.nextText))]
                          }),
                        ],
                        2
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.firstLastButton
                ? _c(
                    "li",
                    {
                      class: [
                        _vm.pageClass,
                        _vm.lastPageSelected() ? _vm.disabledClass : "",
                      ],
                    },
                    [
                      _c(
                        "a",
                        {
                          class: _vm.pageLinkClass,
                          attrs: {
                            tabindex: _vm.lastPageSelected() ? -1 : 0,
                            "aria-disabled": _vm.lastPageSelected()
                              ? "true"
                              : null,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.selectLastPage()
                            },
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.selectLastPage()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t" +
                              _vm._s(_vm.lastButtonText) +
                              "\n\t\t\t"
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            2
          )
        : _c(
            "div",
            { class: _vm.containerClass },
            [
              _vm.firstLastButton
                ? _c(
                    "a",
                    {
                      class: [
                        _vm.pageLinkClass,
                        _vm.firstPageSelected() ? _vm.disabledClass : "",
                      ],
                      attrs: {
                        tabindex: "0",
                        "aria-disabled": _vm.firstPageSelected()
                          ? "true"
                          : null,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.selectFirstPage()
                        },
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.selectFirstPage()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n\t\t\t" + _vm._s(_vm.firstButtonText) + "\n\t\t"
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !(_vm.firstPageSelected() && _vm.hidePrevNext)
                ? _c(
                    "a",
                    {
                      class: [
                        _vm.prevLinkClass,
                        _vm.firstPageSelected() ? _vm.disabledClass : "",
                      ],
                      attrs: {
                        tabindex: "0",
                        "aria-disabled": _vm.firstPageSelected()
                          ? "true"
                          : null,
                        "aria-label": _vm.prevLabel,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.prevPage()
                        },
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.prevPage()
                        },
                      },
                    },
                    [
                      _vm._t("prevContent", function () {
                        return [_vm._v(_vm._s(_vm.prevText))]
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.pages, function (page) {
                return [
                  page.breakView
                    ? _c(
                        "a",
                        {
                          class: [
                            _vm.pageLinkClass,
                            _vm.breakViewLinkClass,
                            page.disabled ? _vm.disabledClass : "",
                          ],
                          attrs: {
                            tabindex: "0",
                            "aria-current": page.selected ? "page" : null,
                            "aria-disabled": page.disabled ? "true" : null,
                          },
                        },
                        [
                          _vm._t("breakViewContent", function () {
                            return [_vm._v(_vm._s(_vm.breakViewText))]
                          }),
                        ],
                        2
                      )
                    : page.disabled
                    ? _c(
                        "a",
                        {
                          class: [
                            _vm.pageLinkClass,
                            page.selected ? _vm.activeClass : "",
                            _vm.disabledClass,
                          ],
                          attrs: {
                            tabindex: "0",
                            "aria-current": page.selected ? "page" : null,
                            "aria-disabled": page.disabled ? "true" : null,
                          },
                        },
                        [
                          _c("span", { staticClass: "screen-reader-text" }, [
                            _vm._v(_vm._s(_vm.pageLabel) + " "),
                          ]),
                          _vm._v(_vm._s(page.content) + "\n\t\t\t"),
                        ]
                      )
                    : _c(
                        "a",
                        {
                          class: [
                            _vm.pageLinkClass,
                            page.selected ? _vm.activeClass : "",
                          ],
                          attrs: {
                            tabindex: "0",
                            "aria-current": page.selected ? "page" : null,
                            "aria-disabled": page.disabled ? "true" : null,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.handlePageSelected(page.index)
                            },
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.handlePageSelected(page.index)
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "screen-reader-text" }, [
                            _vm._v(_vm._s(_vm.pageLabel) + " "),
                          ]),
                          _vm._v(_vm._s(page.content) + "\n\t\t\t"),
                        ]
                      ),
                ]
              }),
              _vm._v(" "),
              !(_vm.lastPageSelected() && _vm.hidePrevNext)
                ? _c(
                    "a",
                    {
                      class: [
                        _vm.nextLinkClass,
                        _vm.lastPageSelected() ? _vm.disabledClass : "",
                      ],
                      attrs: {
                        tabindex: "0",
                        "aria-disabled": _vm.lastPageSelected() ? "true" : null,
                        "aria-label": _vm.nextLabel,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.nextPage()
                        },
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.nextPage()
                        },
                      },
                    },
                    [
                      _vm._t("nextContent", function () {
                        return [_vm._v(_vm._s(_vm.nextText))]
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.firstLastButton
                ? _c(
                    "a",
                    {
                      class: [
                        _vm.pageLinkClass,
                        _vm.lastPageSelected() ? _vm.disabledClass : "",
                      ],
                      attrs: {
                        tabindex: "0",
                        "aria-disabled": _vm.lastPageSelected() ? "true" : null,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.selectLastPage()
                        },
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.selectLastPage()
                        },
                      },
                    },
                    [_vm._v("\n\t\t\t" + _vm._s(_vm.lastButtonText) + "\n\t\t")]
                  )
                : _vm._e(),
            ],
            2
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }